import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { Dvd } from 'interfaces';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import {
  Wrapper,
  DvdsWrapper,
  DvdItem,
  DvdName,
  DvdDate,
  DvdPhoto
} from './Dvds.styles';

export interface DvdsProps {
  dvds: Dvd[];
}

const Dvds = (props: DvdsProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Wrapper>
      <p>{intl.formatMessage({ id: 'dvds.description' }, {
        bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
      })}</p>
      <DvdsWrapper>
      {
        props.dvds.map((dvd) => (
          <Link
            to={`/dvds/${dvd.id}`}
            key={dvd.id}
          >
            <DvdItem vertical={dvd.isVerticalPhoto}>
              <DvdPhoto sorce={`/dvds/${dvd.id}.jpg`} vertical={dvd.isVerticalPhoto}></DvdPhoto>
              <DvdDate>
                {intl.formatMessage({ id: 'albums.releaseDate' })}{' '}
                {intl.formatDate(new Date(dvd.releaseDate), {
                  year: "numeric",
                  month: "short",
                  day: "numeric"
                })}
              </DvdDate>
              <DvdName>
                {locale === AppLocale.EN ? dvd.englishName : dvd.name}
              </DvdName>
            </DvdItem>
          </Link>
        ))
      }
      </DvdsWrapper>
    </Wrapper>
  );
};

export default Dvds;
